module.exports = __webpack_public_path__ + "img/Floodinghighon.a344229f.gif";